import { useAtomValue } from 'jotai';
import { useAnnotationMetadataForId } from '../atoms/annotation-atoms';
import { isVideoLabelingM4EnabledAtom } from '../atoms/m4-atoms';
import { currentFrameAtom } from '../atoms/video-playback-atoms';
import { formatAnswers } from '../utils/frame-timeline-v4';
export function useDynamicAttributesText(annotationIdx?: string): string {
  const isVideoLabelingM4Enabled = useAtomValue(isVideoLabelingM4EnabledAtom);
  const metadata = useAnnotationMetadataForId(annotationIdx ?? '');
  const currentFrame = useAtomValue(currentFrameAtom);
  if (!isVideoLabelingM4Enabled || !annotationIdx || !metadata) {
    return '';
  }
  const dynamicAnswersForFrame = metadata.dynamicAnswers?.find(span => span.frameSpan.start <= currentFrame && currentFrame <= span.frameSpan.end)?.answers;
  return formatAnswers(dynamicAnswersForFrame);
}